import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  template: `
    <div class="d-flex align-items-center justify-content-center" style="min-height:60vh">
      <div class="text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div class="mt-3 text-muted">Procesando autenticación...</div>
      </div>
    </div>
  `,
})
export class AuthCallbackComponent implements OnInit {
  constructor(private router: Router) {}
  ngOnInit(): void {
    // keycloak-angular handles redirect tokens on load
    setTimeout(() => this.router.navigateByUrl('/admin'), 250);
  }
}
